import { AnimatePresence, motion } from 'motion/react';
import * as React from 'react';

import { Stack } from '@/components/layout';
import { cn } from '@/lib/utils';

import { Loader } from './loader';

type LoaderOverlayProps = {
    className?: string;
    text?: string;
    children?: React.ReactNode;
    size?: number | string;
};

export function LoaderOverlay({
    className,
    text = 'Loading...',
    children,
    size = 75,
}: LoaderOverlayProps) {
    return (
        <AnimatePresence>
            <Stack
                as={motion.div}
                className={cn(
                    'bg-background/5 absolute inset-0 backdrop-blur-lg',
                    'items-center justify-center',
                    'z-50',
                    'transition-opacity duration-200',
                    className,
                )}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <Stack className="items-center justify-center gap-6">
                    <Loader size={size} />
                    {text && (
                        <p className="text-foreground font-sans text-sm leading-none font-semibold whitespace-pre">
                            {text}
                        </p>
                    )}
                </Stack>
                {children}
            </Stack>
        </AnimatePresence>
    );
}
